import { render, staticRenderFns } from "./AppSeparator.vue?vue&type=template&id=0fa98260&"
import script from "./AppSeparator.vue?vue&type=script&lang=js&"
export * from "./AppSeparator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports